module.exports = __webpack_public_path__ + "img/16.63a5bca1.jpg";